import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IIcon } from '@shared/icon/icon.model';
import { IconComponent } from '../../../icon/icon.component';

export type IconMode = 'icon' | 'url';
export type IconSize = 'sm' | 'md' | 'xl' | 'custom';

@Component({
    selector: 'app-img-icon',
    templateUrl: './img-icon.component.html',
    styleUrls: ['./img-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class ImgIconComponent {
  readonly url = input<string | null>(null);
  readonly icon = input<IIcon | null>(null);
  readonly iconMode = input<IconMode>('icon');
  readonly size = input<IconSize | undefined>(undefined);
}
